<template>
  <div v-if="items">
    <b-table
      thead-tr-class="z-0"
      style="min-height: auto"
      :items="items"
      :fields="fields"
      :bordered="true"
    >
      <template #cell(authorizedPerson)="data">
        <span>{{
          data.item.authorizedPerson
            ? data.item.authorizedPerson
            : data.item.receiver
              ? data.item.receiver
              : ''
        }}</span
        ><br />
        <span v-if="data.item.position">{{ data.item.position }}</span
        ><br />
        <span v-if="data.item.mobile || data.item.phone"
          >SĐT: {{ data.item.mobile ? data.item.mobile : data.item.phone }}</span
        ><br />
        <!-- <span v-if="data.item.passport">CCCD: {{ data.item.passport }}</span> -->
      </template>
    </b-table>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => {},
      },
      fields: {
        type: Array,
        default() {
          return [
            { key: 'areaName', label: 'ĐCNTT' },
            { key: 'areaAddress', label: 'Địa chỉ' },
            { key: 'authorizedPerson', label: 'Người nhận', class: 'text-center' },
          ]
        },
      },
    },
  }
</script>
